import { IsBoolean, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class PostalAddressDto {
  @IsString()
  @IsNotEmpty()
  country!: string;

  @IsString()
  @IsNotEmpty()
  city!: string;

  @IsString()
  @IsNotEmpty()
  zipCode!: string;

  @IsString()
  @IsNotEmpty()
  street!: string;

  @IsString()
  @IsOptional()
  complement?: string;

  @IsBoolean()
  @IsOptional()
  hasDisabledAccess?: boolean;
}
